import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { UpgradeModule } from '@angular/upgrade/static';
import {FullscreenOverlayContainer, OverlayContainer} from '@angular/cdk/overlay';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { downgradeInjectable, downgradeComponent } from '@angular/upgrade/static';
import { Title } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { TokenInterceptor } from './token/token.interceptor';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { HomeComponent } from './home/home.component';
import { AppComponent } from './app.component';
import { EmptyComponent } from './empty/empty.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { LoginComponent } from './login/login.component';
import { PreviewBalanceComponent } from './previewBalance/previewBalance.component';
import { StaffPlaygroundComponent } from './previewBalance/staffPlayground/staffPlayground.component';
import { PlaygroundChangesComponent } from './previewBalance/staffPlayground/playgroundChangesPanel/playgroundChanges.component';
import { StaffPlaygroundAssignModalComponent } from './previewBalance/staffPlayground/staffPlaygroundAssignModal/staffPlaygroundAssignModal.component';
import { StaffPlaygroundEditRackModalComponent } from './previewBalance/staffPlayground/staffPlaygroundEditRackModal/staffPlaygroundEditRackModal.component';
import { SaveModalComponent } from './previewBalance/save-modal/save-modal.component';
import { SuccessModalComponent } from './services/modal/success/success-modal.component';
import { LoadingModalComponent } from './services/modal/loading/loading-modal.component';
import { ErrorModalComponent } from './services/modal/error/error-modal.component';
import { ConfirmationModalComponent } from './services/modal/confirmation/confirmation-modal.component';
import { YesNoConfirmationModalComponent } from './services/modal/yesnoconfirmation/yesnoconfirmation-modal.component';
import { PreviewAlertsComponent } from './previewBalance/previewAlerts/previewAlerts.component';
import { ProgressBarComponent } from './progressBar/progressBar.component';
import { EmergencyComponent } from './emergency/emergency.component';
import { EmergencyActivitiesComponent } from './emergency/activities/activities.component';
import { EmergencyChartComponent } from './emergency/chart/chart.component';
import { EmergencyStaffComponent } from './emergency/staff/staff.component';
import { EmergencyNotesComponent } from './emergency/notes/notes.component';
import { FlexmonsterPivotModule } from 'ng-flexmonster';
import { CookieService } from 'ngx-cookie-service';
import { UserInfoService } from './main/objects/user-info.service';
import { ApplicationService } from './services/application.service';
import { MainMenuService } from './main/objects/main-menu.service';
import { DataService } from './services/data.service';
import { FlashService } from './services/flash.service';
import { CommonHelperService } from './services/helpers/common-helper.service';
import { ElementIdHelperService } from './services/helpers/element-id-helper.service';
import { ConstantsService } from './services/constants.service';
import { UserService } from './services/user.service';
import { UtilsService } from './services/utils.service';
import { SetupService } from './services/setup.service';
import { ButtonExecutionService } from './services/button-execution.service';
import { CalendarService } from './services/calendar.service';
import { ConfirmationService } from './services/confirmation.service';
import { DailyPlanService } from './services/daily-plan.service';
import { DashboardService } from './services/dashboard.service';
import { DBConstantsService } from './services/dbconstants.service';
import { EmergencyService } from './services/emergency.service';
import { FormService } from './services/form.service';
import { GridService } from './services/grid.service';
import { LocationHelperService } from './services/helpers/location-helper.service';
import { LockoutService } from './services/lockout.service';
import { RefreshFrameHelperService } from './services/helpers/refresh-frame-helper.service';
import { ReportService } from './services/report.service';
import { PreviewScheduleService } from './services/preview-schedule.service';
import { ScheduleGeneratorService } from './services/schedule-generator.service';
import { SignalRService } from './services/signal-r.service';
import { TodaysAssignmentsService } from './services/todays-assignments.service';
import { WatchDndTargetsService } from './services/watch-dnd-targets.service';
import { AdHocActivitiesModalComponent } from './emergency/activities/ad-hoc/adhoc-activities-modal.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HmsEditInputsComponent } from './shared/components/hms-edit-inputs/hms-edit-inputs.component';
import { NumberSpinnerComponent } from './shared/components/number-spinner/number-spinner.component';
import { LocationStrategy, PathLocationStrategy, APP_BASE_HREF } from '@angular/common';
import { LocationUpgradeModule } from '@angular/common/upgrade';
import { $locationShim } from '@angular/common/upgrade';
import { MatSelectModule } from '@angular/material/';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalendarDataService } from './services/calendar-data.service';

//ng1 Deps
import { $uibModalProvider } from './services/ajs-upgraded-providers';
import { $routeParamsProvider } from './services/ajs-upgraded-providers';

@NgModule({
    declarations: [
        AppComponent,
        EmptyComponent,
        HeaderComponent,
        HomeComponent,
        LoginComponent,
        PreviewBalanceComponent,
        StaffPlaygroundComponent,
        PlaygroundChangesComponent,
        EmergencyComponent,
        ProgressBarComponent,
        EmergencyActivitiesComponent,
        EmergencyChartComponent,
        EmergencyStaffComponent,
        EmergencyNotesComponent,
        SaveModalComponent,
        PreviewAlertsComponent,
        AdHocActivitiesModalComponent,
        SuccessModalComponent,
        LoadingModalComponent,
        ErrorModalComponent,
        YesNoConfirmationModalComponent,
        ConfirmationModalComponent,
        HmsEditInputsComponent,
        NumberSpinnerComponent,
        StaffPlaygroundAssignModalComponent,
        StaffPlaygroundEditRackModalComponent
    ],
    entryComponents: [
        LoginComponent,
        HeaderComponent,
        PreviewBalanceComponent,
        EmergencyComponent,
        ProgressBarComponent,
        SaveModalComponent,
        AdHocActivitiesModalComponent,
        SuccessModalComponent,
        LoadingModalComponent,
        ErrorModalComponent,
        YesNoConfirmationModalComponent,
        ConfirmationModalComponent,
        StaffPlaygroundAssignModalComponent,
        StaffPlaygroundEditRackModalComponent
    ],
    imports: [
        BrowserModule,
        UpgradeModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        MatSelectModule,
        BrowserAnimationsModule,
        FlexmonsterPivotModule,
        NgbModule,
        MatProgressBarModule,
        LocationUpgradeModule.config({
          useHash: false
        }),
        AppRoutingModule
    ],
    providers: [
        CookieService,
        TokenInterceptor,
        $uibModalProvider,
        $routeParamsProvider,
        {
            provide: HTTP_INTERCEPTORS,
            useExisting: TokenInterceptor,
            multi: true
        },
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        { provide: APP_BASE_HREF, useValue: '' },
        { provide: 'BASE_URL', useFactory: () => document.getElementsByTagName('base')[0].href },
        { provide: OverlayContainer, useClass: FullscreenOverlayContainer }
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }

declare var angular: any;
angular.module('ntmApp').factory('Title', downgradeInjectable(Title));
angular.module('ntmApp').factory('TokenInterceptor', downgradeInjectable(TokenInterceptor));

angular.module('ntmApp').directive('login', downgradeComponent({ component: LoginComponent }) as angular.IDirectiveFactory);
angular.module('ntmApp').directive('previewBalance', downgradeComponent({ component: PreviewBalanceComponent }) as angular.IDirectiveFactory);
angular.module('ntmApp').directive('emergency', downgradeComponent({ component: EmergencyComponent }) as angular.IDirectiveFactory);
angular.module('ntmApp').directive('ngprogress', downgradeComponent({ component: ProgressBarComponent }) as angular.IDirectiveFactory);
angular.module('ntmApp').directive('appHeader', downgradeComponent({ component: HeaderComponent }) as angular.IDirectiveFactory);
//angular.module('ntmApp').factory('$location', downgradeInjectable($locationShim));
angular.module('ntmApp').factory('UserInfo', downgradeInjectable(UserInfoService));
angular.module('ntmApp').factory('ApplicationService', downgradeInjectable(ApplicationService));
angular.module('ntmApp').factory('MainMenu', downgradeInjectable(MainMenuService));
angular.module('ntmApp').factory('CommonHelper', downgradeInjectable(CommonHelperService));
angular.module('ntmApp').factory('ElementIdHelper', downgradeInjectable(ElementIdHelperService));
angular.module('ntmApp').factory('Constants', downgradeInjectable(ConstantsService));
angular.module('ntmApp').factory('DataService', downgradeInjectable(DataService));
angular.module('ntmApp').factory('UserService', downgradeInjectable(UserService));
angular.module('ntmApp').factory('Utils', downgradeInjectable(UtilsService));
angular.module('ntmApp').factory('FlashService', downgradeInjectable(FlashService));
angular.module('ntmApp').factory('SetupService', downgradeInjectable(SetupService));
angular.module('ntmApp').factory('ButtonExecution', downgradeInjectable(ButtonExecutionService));
angular.module('ntmApp').factory('CalendarDataService', downgradeInjectable(CalendarDataService));
angular.module('ntmApp').factory('CalendarService', downgradeInjectable(CalendarService));
angular.module('ntmApp').factory('ConfirmationService', downgradeInjectable(ConfirmationService));
angular.module('ntmApp').factory('DailyPlanService', downgradeInjectable(DailyPlanService));
angular.module('ntmApp').factory('DashboardService', downgradeInjectable(DashboardService));
angular.module('ntmApp').factory('DBConstants', downgradeInjectable(DBConstantsService));
angular.module('ntmApp').factory('EmergencyService', downgradeInjectable(EmergencyService));
angular.module('ntmApp').factory('FormService', downgradeInjectable(FormService));
angular.module('ntmApp').factory('GridService', downgradeInjectable(GridService));
angular.module('ntmApp').factory('LocationHelperService', downgradeInjectable(LocationHelperService));
angular.module('ntmApp').factory('LockoutService', downgradeInjectable(LockoutService));
angular.module('ntmApp').factory('RefreshFrameHelper', downgradeInjectable(RefreshFrameHelperService));
angular.module('ntmApp').factory('ReportService', downgradeInjectable(ReportService));
angular.module('ntmApp').factory('PreviewScheduleService', downgradeInjectable(PreviewScheduleService));
angular.module('ntmApp').factory('ScheduleGeneratorService', downgradeInjectable(ScheduleGeneratorService));
angular.module('ntmApp').factory('SignalR', downgradeInjectable(SignalRService));
angular.module('ntmApp').factory('TodaysAssignmentsService', downgradeInjectable(TodaysAssignmentsService));
angular.module('ntmApp').factory('WatchDndTargetsService', downgradeInjectable(WatchDndTargetsService));
